<div>
    @if(isLoading){
    <div class="spinner-area">
        <mat-progress-spinner class="spinner" mode="indeterminate" diameter="100"></mat-progress-spinner>
    </div>
    }

    @if(editMode){
        <div class="cc-container">
            <form class="cc-edit-form" [formGroup]="companyInfoForm" novalidate (ngSubmit)="submitCompanyInfo(companyInfoForm.value)">
                @if(_allowTemplateTypeSelection || _allowTemplateEdit){
                    <div class="info-row">
                        <label>Template Name: *</label>
                        <div class="input-container">
                            <input type="text" id="templateName" formControlName="templateName" maxlength="100" data-qa-id="ac_templat_name_add_input">
                            @if(companyInfoForm.controls.templateName?.dirty || companyInfoForm.controls.templateName?.touched) {
                                <div class="form-errors">
                                    @if(companyInfoForm.controls.templateName.errors?.required){
                                        <span>Please enter a template name.</span>
                                    }
                                    @if(hasSpaces$ | async){
                                    <span>Template Name cannot have leading or trailing spaces.</span>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                }

                @if(_allowTemplateTypeSelection){
                    <div class="info-row">
                        <label>Template Type: *</label>
                        <div class="input-container">
                            <mat-select formControlName="templateTypeVal" data-qa-id="ac_templat_type_add_select" ngDefaultControl
                                (selectionChange)="onTemplateTypeChange($event)"
                                [placeholder]="'Select a template type'">
                                @for(item of templateTypeOptions; track item){
                                    <mat-option [value]="item.name">{{ item.name }}</mat-option>
                                }
                            </mat-select>
                            @if(companyInfoForm.controls.templateTypeVal?.dirty || companyInfoForm.controls.templateTypeVal?.touched){
                            <div class="form-errors">
                                @if(companyInfoForm.controls.templateTypeVal.errors){
                                    <span>Please select a template type.</span>
                                }
                            </div>
                            }
                        </div>
                    </div>
                }

                @if(_allowTemplateEdit){
                    <div class="info-row">
                        <label>Template Type: *</label>
                        <div class="input-container">
                            <label>{{ formType | titlecase }}</label>
                        </div>
                    </div>
                }

                @if(formType === accessControlInfoEnum.CONTRACT && !_allowTemplateTypeSelection && !_allowTemplateEdit){
                    <div class="info-row">
                        <label>Select Template: </label>
                        <div class="input-container">
                            <kendo-combobox
                                class="template-smart-search"
                                formControlName="contractTemplate"
                                data-qa-id="ac_contract_template_select"
                                [data]="contractTemplates"
                                textField="name"
                                valueField="accessControlContractCompanyTemplateId"
                                [valuePrimitive]="true"
                                placeholder="Select template"
                                [kendoDropDownFilter]="filterSettings"
                                (selectionChange)="contractTemplateSelection($event)">
                            </kendo-combobox>
                        </div>
                    </div>
                }

                @if(formType === accessControlInfoEnum.CLIENT && !_allowTemplateTypeSelection && !_allowTemplateEdit){
                    <div class="info-row">
                        <label>Select Template: </label>
                        <div class="input-container">
                            <kendo-combobox
                                class="template-smart-search"
                                formControlName="clientTemplate"
                                data-qa-id="ac_client_template_select"
                                [data]="clientTemplates"
                                textField="name"
                                valueField="accessControlClientCompanyTemplateId"
                                [valuePrimitive]="true"
                                placeholder="Select template"
                                [kendoDropDownFilter]="filterSettings"
                                (selectionChange)="clientTemplateSelection($event)">
                            </kendo-combobox>
                        </div>
                    </div>
                }

                @if(formType){
                    @if(formType === accessControlInfoEnum.CONTRACT){
                        <div class="info-row">
                            <label>Contract Company Name: </label>
                            <input type="text" id="companyName" formControlName="companyName" maxlength="100">
                        </div>
                    }

                    <div class="info-row">
                        <label>{{formType === accessControlInfoEnum.CONTRACT ? 'Contract Contact Name' : 'Client Contact Name'}}: </label>
                        <input type="text" id="contactName" formControlName="contactName" maxlength="100">
                    </div>

                    <div class="info-row">
                        <label>{{formType === accessControlInfoEnum.CONTRACT ? 'Contract Contact Phone' : 'Client Contact Phone'}}: </label>
                        <div class="input-container">
                            <input type="tel" id="contactPhone" formControlName="contactPhone" [mask]="phoneMask">
                            @if(companyInfoForm.controls.contactPhone.invalid && (companyInfoForm.controls.contactPhone?.dirty || companyInfoForm.controls.contactPhone?.touched)){
                            <div class="form-errors">
                                @if(companyInfoForm.controls.contactPhone.errors.wrongFormat){
                                    <span>Please enter a valid phone number (e.g. 555-555-5555).</span>
                                }
                            </div>
                            }
                        </div>
                    </div>

                    <div class="info-row">
                        <label>{{formType === accessControlInfoEnum.CONTRACT ? 'Contract Company Email' : 'Client Contact Email'}}: </label>
                        <div class="input-container">
                            <input type="contactEmail" id="contactEmail" formControlName="contactEmail" maxlength="50">
                            @if(companyInfoForm.controls.contactEmail.invalid && (companyInfoForm.controls.contactEmail?.dirty || companyInfoForm.controls.contactEmail?.touched)){
                                <div class="form-errors">
                                    @if(companyInfoForm.controls.contactEmail?.errors.email){
                                        <span >Email must be a valid email address.</span>
                                    }
                                </div>
                            }
                        </div>
                    </div>

                    @if(formType === accessControlInfoEnum.CONTRACT){
                        <div class="info-row">
                            <label>Contractor Type: </label>
                            <input type="text" id="contractorType" formControlName="contractorType" maxlength="50">
                        </div>
                    }

                    @if(formType === accessControlInfoEnum.CLIENT){
                        <div class="info-row">
                            <label>Cost Center: </label>
                            <input type="text" id="costCenter" formControlName="costCenter" maxlength="250">
                        </div>

                        <div class="info-row">
                            <label>Compliance Approval: </label>
                            <input type="text" id="complianceApproval" formControlName="complianceApproval" maxlength="50">
                        </div>
                    }

                    <div class="info-row full-width">
                        <label>Other Info: </label>
                        <nova-rich-editor id="otherInfo" name="otherInfo" data-qa-id="company_info_edit_other_info_textarea"
                            (valueChange)="otherInfoChanged($event)" [(value)]="otherInfoEdit" class="inline text-editor"
                            [maxlength]="1000" [useIframe]="false">
                        </nova-rich-editor>
                    </div>
                }

                <div class="info-row button-actions">
                    @if(formType === accessControlInfoEnum.CONTRACT && !_allowTemplateTypeSelection && !_allowTemplateEdit){
                        <button type="button" mat-raised-button color="primary" (click)="addNewTemplateName(accessControlTemplateTypeEnum.CONTRACT)" data-qa-id="company_info_edit_create_templates_button">
                            Create Template &amp; Save
                        </button>
                    }

                    @if(formType === accessControlInfoEnum.CLIENT && !_allowTemplateTypeSelection && !_allowTemplateEdit){
                        <button type="button" mat-raised-button color="primary" (click)="addNewTemplateName(accessControlTemplateTypeEnum.CLIENT)" data-qa-id="company_info_edit_create_templates_button">
                            Create Template &amp; Save
                        </button>
                    }
                    
                    @if(_allowTemplateEdit){
                        <button mat-raised-button type="button" color="warn" (click)="delete()">
                            Delete
                        </button>
                    }

                    <button mat-raised-button type="submit" [disabled]="companyInfoForm.invalid || (companyInfoForm.dirty && companyInfoForm.invalid) || companyInfoForm.pristine" color="primary" data-qa-id="company_info_edit_submit_button">
                        Save
                    </button>

                    <button mat-button class="cancel-btn" (click)="cancel()" data-qa-id="company_info_edit_cancel_button">
                        Cancel
                    </button>
                </div>

                @if(_allowTemplateEdit){
                    <div class="info-row update-profile">
                        <mat-checkbox formControlName="updateCandidateCompanies">Update all associated profiles</mat-checkbox>
                    </div>
                }
            </form>
        </div>
    }
    @else{
        <div class="cc-container">
            @if(formType === accessControlInfoEnum.CONTRACT){
                <div class="cc-info">
                    @if(_allowTemplateEdit){
                        <div class="info-row">
                            <label>Template Name: </label>
                            <span class="info-text">{{ companyInfo?.contractTemplate?.name }}</span>
                        </div>

                        <div class="info-row">
                            <label>Template Type: </label>
                            <span class="info-text">{{ formType | titlecase }}</span>
                        </div>
                    }


                    
                    <div class="info-row">
                        <label>Contract Company Name: </label>
                        <span class="info-text">{{ companyInfo?.companyName }}</span>
                    </div>
                    <div class="info-row">
                        <label>Contract Company Email: </label>
                        <span class="info-text">{{ companyInfo?.contactEmail }}</span>
                    </div>
                    <div class="info-row">
                        <label>Contract Contact Name: </label>
                        <span class="info-text">{{ companyInfo?.contactName }}</span>
                    </div>
                    <div class="info-row">
                        <label>Contractor Type: </label>
                        <span class="info-text">{{ companyInfo?.contractorType }}</span>
                    </div>
                    <div class="info-row">
                        <label>Contract Contact Phone: </label>
                        <span class="info-text">{{ companyInfo?.contactPhone | phoneFormat }}</span>
                    </div>
                    <div class="info-row full-width">
                        <label>Other Info: </label>
                        <span [innerHTML]="companyInfo?.otherInfo ?? '' | sanitizer"></span>
                    </div>
                </div>
            }

            @if(formType === accessControlInfoEnum.CLIENT){
                <div class="cc-info">

                    @if(_allowTemplateEdit){
                        <div class="info-row">
                            <label>Template Name: </label>
                            <span class="info-text">{{ companyInfo?.clientTemplate?.name }}</span>
                        </div>
                        <div class="info-row">
                            <label>Template Type: </label>
                            <span class="info-text">{{ formType | titlecase }}</span>
                        </div>
                    }

                    <div class="info-row">
                        <label>Client Contact Name: </label>
                        <span class="info-text">{{ companyInfo?.contactName }}</span>
                    </div>
                    <div class="info-row">
                        <label>Client Contact Email: </label>
                        <span class="info-text">{{ companyInfo?.contactEmail }}</span>
                    </div>

                    <div class="info-row">
                        <label>Client Contact Phone: </label>
                        <span class="info-text">{{ companyInfo?.contactPhone | phoneFormat}}</span>
                    </div>
                    <div class="info-row">
                        <label>Cost Center: </label>
                        <span class="info-text">{{ companyInfo?.costCenter }}</span>
                    </div>
                    <div class="info-row">
                        <label>Compliance Approval: </label>
                        <span class="info-text">{{ companyInfo?.complianceApproval }}</span>
                    </div>
                    <div class="info-row full-width">
                        <label>Other Info: </label>
                        <span [innerHTML]="companyInfo?.otherInfo ?? '' | sanitizer"></span>
                    </div>
                </div>
            }
            <div class="cc-edit">
                <button mat-icon-button (click)="editCompanyInfo()" color="primary" data-qa-id="company_info_edit_edit-icon_button">
                    <mat-icon class="edit-icon">edit</mat-icon>
                </button>
            </div>
        </div>
    }
</div>
